<template>
  <div id="forgot-password">
    <div class="form">
      <h3>{{ $t("main.varificationTitle") }}</h3>
      <span>{{ $t("main.verificationDescription") }}</span>
      <div v-if="!verificationSent" class="btn" @click="verification">
        {{ $t("main.varificationBtn") }}
      </div>
      <div v-else>{{ $t("main.verificationSent") }}</div>
      <TurnStile :resetToken="resetToken" @set-token="setToken" />
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import TurnStile from "@/components/TurnStileVue2.vue";

export default {
  components: {
    TurnStile
  },
  data() {
    return {
      verificationSent: false,
      username: null,
      localToken: "",
      resetToken: false
    };
  },
  computed: {},
  activated() {
    if (!this.$route.params.usr_name) {
      this.$router.push({ name: "Home" });
    } else {
      this.username = this.$route.params.usr_name;
    }
  },
  methods: {
    setToken(e) {
      this.localToken = e;
    },
    async verification() {
      // await this.$recaptchaLoaded();
      // const token = await this.$recaptcha("verification");
      let params = {
        token: this.localToken,
        usr_username: this.username
      };
      this.resetToken = !this.resetToken;
      api
        .resendVerification(params)
        .then(res => {
          console.log(res);
          this.verificationSent = true;
        })
        .catch(e => {
          this.$toast.error(this.$t("main.verificationSentError"), {
            duration: 8000
          });
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
#forgot-password {
  height: 50vh;
  min-height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .form {
    border: 1px solid silver;
    padding: 30px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px 10px;

    h3 {
      margin-bottom: 0px;
    }
    .btn {
      // // background: #e9786e;
      // text-transform: uppercase;
      // color: white;
      // width: calc(50% - 7px);
      // font-weight: bold;
      // font-size: 10px;
      // text-transform: none;

      &.disabled {
        opacity: 0.7;
      }
    }
  }
}
</style>
